<template>
  <div class="main">
    <div class="d-flex justify-content-center" v-if="loadingSpinner">
      <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
    </div>

    <b-row v-if="!loadingSpinner">
      <b-col cols="12" class="mt-1">
        <div class="d-flex flex-wrap justify-content-center d-md-flex d-lg-none">
  <b-button disabled variant="primary" class="my-1 w-100 d-block d-md-none"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Not Started = " }} {{ this.notStarted }}
  </b-button>
  <b-button disabled variant="primary" class="my-1 w-100 d-block d-md-none"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Started = " }} {{ this.started }}
  </b-button>
  <b-button disabled variant="primary" class="my-1 w-100 d-block d-md-none"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Completed = " }} {{ this.completed }}
  </b-button>
  <b-button disabled variant="primary" class="my-1 w-100 d-block d-md-none"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Cancelled = " }} {{ this.cancelled }}
  </b-button>
  <b-button disabled variant="primary" class="my-1 w-100 d-block d-md-none"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Blocked = " }} {{ this.blocked }}
  </b-button>
</div>

<!-- Original Layout for Larger Screens -->
<div class="d-none d-lg-flex flex-wrap justify-content-center">
  <b-button disabled variant="primary" class="my-1 mx-1"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Not Started = " }} {{ this.notStarted }}
  </b-button>
  <b-button disabled variant="primary" class="my-1 mx-1"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Started = " }} {{ this.started }}
  </b-button>
  <b-button disabled variant="primary" class="my-1 mx-1"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Completed = " }} {{ this.completed }}
  </b-button>
  <b-button disabled variant="primary" class="my-1 mx-1"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Cancelled = " }} {{ this.cancelled }}
  </b-button>
  <b-button disabled variant="primary" class="my-1 mx-1"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Blocked = " }} {{ this.blocked }}
  </b-button>
</div>


        <div class="d-flex justify-content-end">
          <b-button variant="primary" v-b-modal.modal-addcategory class="my-1" to="/jobcard/add">
            Process Orders
          </b-button>
        </div>
      </b-col>

      <b-col cols="12"  md="2" sm="2" class="my-1">
        <b-form-group class="mb-0">
          <label class="d-inline-block text-sm-left mr-50">Per page</label>
          <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" />
        </b-form-group>
      </b-col>
      <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
        <b-button variant="outline-danger" @click="clearFilters">
          Clear Filters
        </b-button>
      </b-col>
      <b-col cols="12">
        <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredJobcards"
          :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
          @filtered="onFiltered" @row-clicked="onRowClicked">

          <!-- Job Card Name Filter -->
          <template #head(name)="scope">
            <div class="d-flex flex-column">
              <span>Job Card Name</span>
              <b-form-input v-model="filters.name" placeholder="Search Job Card Name" size="sm"
                @input="currentPage = 1" />
            </div>
          </template>

          <template #head(startDate)="scope">
            <div class="d-flex flex-column">
              <span>Start Date</span>
              <DatePicker v-model="filters.startDate" format="YYYY-MM-DD" placeholder="Select Start Date"
                @change="currentPage = 1" style="width: 100%;" size="sm" />
            </div>
          </template>

          <template #head(endDate)="scope">
            <div class="d-flex flex-column">
              <span>End Date</span>
              <DatePicker v-model="filters.endDate" format="YYYY-MM-DD" placeholder="Select End Date"
                @change="currentPage = 1" style="width: 100%;" size="sm" />
            </div>
          </template>

          <!-- Status Filter -->
          <template #head(status)="scope">
            <div class="d-flex flex-column">
              <span>Status</span>
              <b-form-select v-model="filters.status" :options="statusOptions" placeholder="Select Status" size="sm"
                @input="currentPage = 1" />
            </div>
          </template>

          <!-- Priority Filter -->
          <template #head(priority)="scope">
            <div class="d-flex flex-column">
              <span>Priority</span>
              <b-form-select v-model="filters.priority" :options="priorityOptions" placeholder="Select Priority"
                size="sm" @input="currentPage = 1" />
            </div>
          </template>

          <template v-slot:cell(name)="data">
            <b-link variant="primary" :to="getId(data.item.id)">
              {{ data.item.name }}
            </b-link>
          </template>
          <template #cell(startDate)="data">
            {{ dayjs(data.value).format("DD/MM/YYYY") }}
          </template>

          <template #cell(endDate)="data">
            {{ dayjs(data.value).format("DD/MM/YYYY") }}
          </template>
          <!-- <template #cell(deliveryDate)="data">
            {{ dayjs(data.value).format("DD/MM/YYYY") }}
          </template> -->
          <template v-slot:cell(status)="data">
            <b-badge v-if="data.item.status === 0" variant="info">
              <span>Not Started</span>
            </b-badge>
            <b-badge v-else-if="data.item.status === 1" variant="secondary">
              <span>Started</span>
            </b-badge>
            <b-badge v-else-if="data.item.status === 2" variant="primary">
              <span>Completed</span>
            </b-badge>
            <b-badge v-else-if="data.item.status === 3" variant="danger">
              <span>Cancelled</span>
            </b-badge>
            <b-badge v-else-if="data.item.status === 4" variant="warning">
              <span>Blocked</span>
            </b-badge>
          </template>
          <!-- <template #cell(actions)="data">
            <b-dropdown v-if="data.item.status === 2" variant="link" toggle-class="text-decoration-none" no-caret>
              <template v-slot:button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
              </template>
              <b-dropdown-item v-b-modal.modal-edit :to="addtimesheet(data.item.id)">
                <feather-icon icon="ClockIcon" class="mr-50" />
                <span>Log Time</span>
              </b-dropdown-item>
            </b-dropdown>
          </template> -->
          <template v-slot:cell(complete)="data">
            <b-form-checkbox v-if="data.item.status == 1 || data.item.status == 3 || data.item.status == 4"
              :checked="isChecked(data.item.id)" :disabled="isDisabled(data.item.status)"
              @change="checkboxChanged(data.item.id, $event)">
            </b-form-checkbox>
          </template>
        </b-table>
        <!-- <p>Total Records: {{ this.totalRecords }}</p> -->
        <div class="d-flex justify-content-end">
          <!-- <b-button 
    variant="primary" 
    class="my-1" 
    @click="completeJobCards" 
    :disabled="apiLoading"
  >
    Complete Job Cards
  </b-button> -->
        </div>

        <b-alert variant="danger" show v-if="error" class="d-flex justify-content-center">
          <h4 class="alert-heading">{{ errorMessage }}</h4>
        </b-alert>
        <b-alert variant="info" show v-if="!jobCardLoading && jobcardList.length === 0 && !error" class="d-flex justify-content-center">
          <h4 class="alert-heading">No jobcards Yet</h4>
        </b-alert>

        <div class="d-flex justify-content-center mb-1">
          <b-spinner variant="success" label="Spinning" block show v-if="jobCardLoading && !error"
            style="width: 3rem; height: 3rem"></b-spinner>
        </div>
      </b-col>

      <b-col cols="12">
        <b-pagination v-model="currentPage" :total-rows="filteredJobcards.length" :per-page="perPage" align="center" size="sm"
          class="my-0" />
        <b-form-group>
          Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
        </b-form-group>
      </b-col>

    </b-row>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BDropdownItem,
  BSpinner,
  BLink,
  BAlert,
  BFormCheckbox,
} from "bootstrap-vue";

import { mapActions, mapGetters } from "vuex";
import dayjs from "dayjs";

export default {
  components: {
    BTable,
    BAlert,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    BSpinner,
    BLink,
    BFormCheckbox,
    DatePicker
  },
  data() {
    return {
      dayjs,
      loadingSpinner: true,
      perPage: 5,
      errorMessage: "",
      categoryName: "",
      apiLoading: false,
      error: false,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 0,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      selectedItems: [],
      notStarted: 0,
      started: 0,
      completed: 0,
      cancelled: 0,
      blocked: 0,
      statusOptions: [
        { value: '', text: 'All' },
        { value: 0, text: 'Not Started' },
        { value: 1, text: 'Started' },
        { value: 2, text: 'Completed' },
        { value: 3, text: 'Cancelled' },
        { value: 4, text: 'Blocked' },
      ],
      selectedStatus: '', // Default is no filter
      totalRecords: 0,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      currentStatus: this.$route.params.status ?? null,
      filters: {
        name: "",
        status: "",
        priority: "",
        startDate: null,
        endDate: null,
      },
      priorityOptions: [
        { value: "", text: "All" },
        { value: "High", text: "High" },
        { value: "Medium", text: "Medium" },
        { value: "Low", text: "Low" },
      ],
      fields: [
        {
          key: "name",
          label: "Job Card Name",
          sortable: true
        },
        {
          key: "startDate",
          label: "Start Date",
          sortable: true
        },
        {
          key: "endDate",
          label: "End Date",
          sortable: true
        },
        {
          key: "status",
          label: "Status",
          sortable: true
        },
        {
          key: "priority",
          label: "Priority",
          sortable: true
        },
        // {
        //   key: "actions",
        //   label: "Actions",
        // },
      ],
    };
  },
  computed: {
    filteredJobcards() {
      return this.jobcardList.filter((jobcard) => {
        // Match Job Card Name
        const matchesName = !this.filters.name ||
          (jobcard.name && jobcard.name.toLowerCase().includes(this.filters.name.toLowerCase()));

        // Match Status
        const matchesStatus = this.filters.status === "" ||
          jobcard.status === parseInt(this.filters.status);

        // Match Priority
        const matchesPriority = !this.filters.priority ||
          jobcard.priority === this.filters.priority;

        // Match Start Date
        const matchesStartDate = !this.filters.startDate ||
          (jobcard.startDate && new Date(jobcard.startDate).toDateString() === new Date(this.filters.startDate).toDateString());

        // Match End Date
        const matchesEndDate = !this.filters.endDate ||
          (jobcard.endDate && new Date(jobcard.endDate).toDateString() === new Date(this.filters.endDate).toDateString());

        // Combine all filters
        return matchesName && matchesStatus && matchesPriority && matchesStartDate && matchesEndDate;
      });
    },
    totalRows() {
      return this.filteredJobcards.length; // Automatically adjust totalRows based on the filtered list
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("jobcardModule", {
      jobcardList: "jobcards",
      jobCardLoading: "loading",
    }),

    ...mapGetters("productModule", {
      productList: "product",
      loading: "loading",
    }),
  },
  methods: {
    clearFilters() {
      this.filters = {
        name: "",
        status: "",
        priority: "",
        startDate: null,
        endDate: null,
      };
      this.currentPage = 1; // Reset pagination to the first page
    },
    showSuccess() {
      this.$swal({
        title: "Job Cards Completed!",
        text: "You have successfully completed the selected Job Cards!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
      this.getJobcardListAction(this.currentStatus);
      this.getJobcardStatusCount();
    },

    showError(data) {
      this.$swal({
        title: "Error!",
        text: data.response.data.message,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
      this.getJobcardListAction(this.currentStatus);
      this.getJobcardStatusCount();
    },
    isChecked(itemId) {
      return this.selectedItems.some(item => item.id === itemId);
    },
    isDisabled(status) {
      return [0, 2, 3, 4].includes(status);
    },

    // addtimesheet(item) {
    //   return "/jobcardtimesheet/add/" + item;
    // },

    checkboxChanged(itemId, isChecked) {
      const itemStatus = 2;
      const existingItemIndex = this.selectedItems.findIndex(item => item.id === itemId);

      if (isChecked) {
        if (existingItemIndex === -1) {
          this.selectedItems.push({ id: itemId, status: itemStatus });
        } else {
          this.selectedItems[existingItemIndex].status = itemStatus;
        }
      } else {
        if (existingItemIndex !== -1) {
          this.selectedItems.splice(existingItemIndex, 1);
        }
      }
      console.log(this.selectedItems);
    },
    completeJobCards() {
      this.apiLoading = true;

      // Showing swal loader
      this.$swal({
        title: 'Loading...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          this.$swal.showLoading();
        }
      });

      this.updateMultipleJobCardAction(this.selectedItems)
        .then(() => {
          this.$swal.close();
          this.showSuccess();
        })
        .catch(error => {
          this.$swal.close();
          this.showError(error);
        })
        .finally(() => {
          this.apiLoading = false;
        });
    },

    onRowClicked(item) {
      // This method will handle the row click and navigate to the detail page
      this.$router.push(this.getId(item.id));
    },

    getId(data) {
      return "/jobcard/view/" + data;
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getJobcardStatusCount() {
      const counts = {
        notStarted: 0,
        started: 0,
        completed: 0,
        cancelled: 0,
        blocked: 0,
      };
      this.jobcardList.forEach((jobcard) => {
        if (!jobcard.isActive) return;

        switch (jobcard.status) {
          case 0:
            counts.notStarted++;
            break;
          case 1:
            counts.started++;
            break;
          case 2:
            counts.completed++;
            break;
          case 3:
            counts.cancelled++;
            break;
          case 4:
            counts.blocked++;
            break;
          default:
            break;
        }
      });
      this.notStarted = counts.notStarted;
      this.started = counts.started;
      this.completed = counts.completed;
      this.cancelled = counts.cancelled;
      this.blocked = counts.blocked;
    },
    getProductName(id) {
      for (let i = 0; i < this.productList.length; i++) {
        if (this.productList[i].id == id) {
          return this.productList[i].name;
        }
      }
    },

    ...mapActions("jobcardModule", ["getJobcardListAction", "updateMultipleJobCardAction"]),
    ...mapActions("productModule", ["getProductListAction"]),
  },
  async mounted() {
    this.getJobcardStatusCount();
    setTimeout(() => {
      this.loadingSpinner = false;
    }, 5000);
    await this.getJobcardListAction(this.currentStatus)
      .then(() => {
        this.totalRows = this.jobcardList.length;
      })
      .catch((response) => {
        this.error = true;
        this.errorMessage = response.response.data.message;

      });
    this.getJobcardStatusCount();
  },
};
</script>
